import { useState } from 'react';
import { PricingBar } from 'components/PricingBar/PricingBar';
import { useAppStore } from '../../store/store.js';
import s from './PricingGraph.module.css';

export const PricingGraph = props => {
  const companys = props.companys;
  const setMonthRes = props.monthResult;
  const setYearRes = props.yearResult;
  const [nameColumn, setNameColumn] = useState('');
  const { storageRange, transferRange, scalewayVariant, bunnyVariant } =
    useAppStore();

  const calculateTotalPrice = provider => {
    let totalPrice = 0;
    const { price } = provider;
    const month = parseFloat(30);
    const year = parseFloat(365);

    if (price.storage.multi || price.storage.single) {
      if (storageRange > 75) {
        totalPrice += (storageRange - 75) * price.storage[scalewayVariant];
      }

      if (transferRange > 75) {
        totalPrice += (transferRange - 75) * price.transfer;
      }
    } else if (price.storage.hdd || price.storage.ssd) {
      totalPrice += storageRange * price.storage[bunnyVariant];
      totalPrice += transferRange * price.transfer;
    } else {
      totalPrice += storageRange * price.storage;
      totalPrice += transferRange * price.transfer;
    }

    if (price.min && totalPrice < price.min) {
      totalPrice = price.min;
    }

    if (price.max && totalPrice > price.max) {
      totalPrice = price.max;
    }

    if (provider.name === nameColumn) {
      setMonthRes(totalPrice * month);
      setYearRes(totalPrice * year);
    }
    return totalPrice.toFixed(2);
  };

  const handleClick = company => {
    setNameColumn(company.name);
  };

  return (
    <div className={s.graph}>
      {companys &&
        companys.map((company, index) => (
          <PricingBar
            key={index}
            company={company}
            total={calculateTotalPrice(company)}
            onClick={() => handleClick(company)}
          />
        ))}
    </div>
  );
};
